// extracted by mini-css-extract-plugin
export default {"container":"IZ-z","heading":"JZ-z","links":"KZ-z","copy":"LZ-z","subCopy":"MZ-z","linksLeft":"NZ-z","linksCenter":"OZ-z","linksRight":"PZ-z","link":"QZ-z","onlyLink":"RZ-z"};